module.exports = __webpack_public_path__ + "static/media/mapPin.5cf1da3a.svg";